import { Typography, Box } from '@material-ui/core';

import { LightTooltip } from 'components';
import { RenderComponentProps } from 'components/DataTable/types';

import { useStyles } from './styles';

type SchoolNameRenderData = {
  name?: string;
  brandsName?: string;
} | null;

export function SchoolNameRender({
  data,
}: RenderComponentProps<SchoolNameRenderData>): JSX.Element {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      width="100%"
      className={classes.root}
    >
      <LightTooltip title={data?.name || 'N/A'} placement="top">
        <Typography variant="subtitle2" noWrap>
          {data?.name || 'N/A'}
        </Typography>
      </LightTooltip>
      <LightTooltip title={data?.brandsName || 'N/A'} placement="top">
        <Typography variant="subtitle2" noWrap className={classes.brandsName}>
          {data?.brandsName || 'N/A'}
        </Typography>
      </LightTooltip>
    </Box>
  );
}
